import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Typography, mediaQuery } from '@lacedltd/laced-components'
import { keyframes } from '@emotion/react'

const fadeIn = keyframes`
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: '9.375rem';
  }
`

const fadeOut = keyframes`
  from {
    opacity: 1;
    max-height: 9.375rem;
  }
  to {
    opacity: 0;
    max-height: 0;
  }
`

export const ProductDeliveryAnimation = styled.section<{
  visible?: boolean
  animate?: boolean
}>(
  ({ visible }) => ({
    position: 'relative',
    overflow: 'hidden',
    maxHeight: visible ? '9.375rem' : 0
  }),
  ({ animate, visible }) =>
    animate && {
      animation: visible
        ? `${fadeIn} 0.8s ease-in-out forwards`
        : `${fadeOut} 0.8s ease-in-out forwards`
    }
)

export const ProductDeliveryLabel = styled.div({
  padding: `${tokens.spacing[4]} ${tokens.spacing[5]}`,
  border: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[200]}`,
  marginTop: tokens.spacing[7],
  display: 'flex',
  flexDirection: 'column',
  [mediaQuery.m.max]: {
    padding: tokens.spacing[3]
  }
})

export const ProductDeliveryTextWrap = styled.div({
  display: 'flex',
  alignItems: 'flex-start'
})

export const EstimatedDeliveryText = styled(Typography.Text)({
  marginBottom: tokens.spacing[2],
  color: tokens.color.airJordan.p,
  marginRight: 'auto',
  paddingRight: tokens.spacing[2],

  [mediaQuery.s.max]: {
    fontSize: tokens.fontSize[2]
  }
})

export const PremiumDeliveryAvailableText = styled(Typography.Text)({
  [mediaQuery.s.max]: {
    fontSize: tokens.fontSize[1]
  }
})
